<template>
  <div class="sms-logs-wrapper">
    <v-card
      :loading="loading || loadingUsers"
      class="fill-width table_theme card-theme sms-custom-container"
    >
      <div class="d-flex align-center px-3" style="gap: 8px; margin-top: 0;">
        <span style="font-size: 13px; font-weight: 600; color: #333; white-space: nowrap; margin-right: 4px;">Communications Management</span>
        <v-progress-circular v-if="loading || loadingUsers" indeterminate color="primary" size="12" width="2"></v-progress-circular>
        <v-tabs v-model="activeTab" color="#29ABE2" slider-color="#29ABE2" height="26" style="flex: 0 0 auto; max-width: 300px;">
          <v-tab style="font-size: 10px; min-width: 60px; padding: 0 6px; text-transform: uppercase;">Users</v-tab>
          <v-tab style="font-size: 10px; min-width: 60px; padding: 0 6px; text-transform: uppercase;">SMS Logs</v-tab>
          <v-tab style="font-size: 10px; min-width: 60px; padding: 0 6px; text-transform: uppercase;">SMS Check</v-tab>
        </v-tabs>
        <span style="color: #ddd; font-size: 14px;">|</span>
        <template v-if="activeTab === 1">
          <span style="font-size: 10px; white-space: nowrap;">Total <b>{{ logsTotal }}</b></span>
          <template v-for="(item, index) in logStatusCounts">
            <span :key="'d-' + index" style="color: #ccc; font-size: 10px;">|</span>
            <span :key="item.status" class="status-stats-bar__item--clickable" @click="toggleLogStatus(item.status)" style="font-size: 10px; cursor: pointer; white-space: nowrap;">
              <v-icon style="font-size: 5px; margin-right: 1px;" :style="{ color: getStatusDotColor(item.status) }">brightness_1</v-icon>
              {{ item.status.replace(/_/g, ' ') }} <b>{{ item.count }}</b>
            </span>
          </template>
        </template>
        <template v-if="activeTab === 0">
          <span class="cm-stat">Total <b>{{ users.length }}</b></span>
          <span class="cm-pipe">|</span>
          <template v-for="(item, index) in userStatusCounts">
            <span :key="'sd-' + index" v-if="index > 0" class="cm-pipe">|</span>
            <span :key="'sc-' + item.status" class="cm-stat cm-stat--click" @click="userStatusFilter = userStatusFilter === item.status ? null : item.status">
              <v-icon class="cm-dot" :style="{ color: item.status === 'Active' ? '#2e7d32' : item.status === 'Invited' ? '#1565C0' : item.status === 'Onboarding' ? '#FF8F00' : '#9e9e9e' }">brightness_1</v-icon>
              {{ item.status }} <b>{{ item.count }}</b>
            </span>
          </template>
          <span class="cm-pipe">|</span>
          <span class="cm-stat"><v-icon class="cm-dot" style="color: #2e7d32;">brightness_1</v-icon> SMS <b>{{ userCounts.sms_consent }}</b></span>
          <span class="cm-pipe">|</span>
          <span class="cm-stat"><v-icon class="cm-dot" style="color: #2e7d32;">brightness_1</v-icon> Email <b>{{ userCounts.email_consent }}</b></span>
          <span class="cm-pipe">|</span>
          <span class="cm-stat"><v-icon class="cm-dot" style="color: #C62828;">brightness_1</v-icon> SMS Unsub <b>{{ userCounts.sms_unsubscribed }}</b></span>
          <span class="cm-pipe">|</span>
          <span class="cm-stat"><v-icon class="cm-dot" style="color: #C62828;">brightness_1</v-icon> Email Unsub <b>{{ userCounts.email_unsubscribed || 0 }}</b></span>
        </template>
        <v-spacer></v-spacer>
        <v-chip v-if="userStatusFilter && activeTab === 0" close x-small color="#29ABE2" text-color="white" @click:close="userStatusFilter = null">{{ userStatusFilter }}</v-chip>
        <v-chip v-if="statusFilter && activeTab === 1" close x-small color="#29ABE2" text-color="white" @click:close="statusFilter = null; resetAndFetchLogs()">{{ statusFilter }}</v-chip>
        <template v-if="activeTab === 1">
          <v-menu v-model="startDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="startDate" placeholder="Start" readonly dense hide-details clearable v-bind="attrs" v-on="on" class="cm-input" @click:clear="startDate = null; resetAndFetchLogs()"></v-text-field>
            </template>
            <v-date-picker v-model="startDate" no-title scrollable @input="startDateMenu = false; resetAndFetchLogs()"></v-date-picker>
          </v-menu>
          <v-menu v-model="endDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="endDate" placeholder="End" readonly dense hide-details clearable v-bind="attrs" v-on="on" class="cm-input" @click:clear="endDate = null; resetAndFetchLogs()"></v-text-field>
            </template>
            <v-date-picker v-model="endDate" no-title scrollable @input="endDateMenu = false; resetAndFetchLogs()"></v-date-picker>
          </v-menu>
          <v-btn rounded text color="#29ABE2" x-small @click="exportCsv" :disabled="logs.length === 0" style="font-size: 10px; min-width: 30px; padding: 0 4px;">CSV</v-btn>
        </template>
        <template v-if="activeTab === 0">
          <v-menu v-model="usersStartDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="usersStartDate" placeholder="Start" readonly dense hide-details clearable v-bind="attrs" v-on="on" class="cm-input" @click:clear="usersStartDate = null; resetAndFetchUsers()"></v-text-field>
            </template>
            <v-date-picker v-model="usersStartDate" no-title scrollable @input="usersStartDateMenu = false; resetAndFetchUsers()"></v-date-picker>
          </v-menu>
          <v-menu v-model="usersEndDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="usersEndDate" placeholder="End" readonly dense hide-details clearable v-bind="attrs" v-on="on" class="cm-input" @click:clear="usersEndDate = null; resetAndFetchUsers()"></v-text-field>
            </template>
            <v-date-picker v-model="usersEndDate" no-title scrollable @input="usersEndDateMenu = false; resetAndFetchUsers()"></v-date-picker>
          </v-menu>
          <v-btn rounded text color="#29ABE2" x-small @click="exportUsersCsv" :disabled="users.length === 0" style="font-size: 10px; min-width: 30px; padding: 0 4px;">CSV</v-btn>
        </template>
        <v-text-field v-model="search" placeholder="Search..." single-line hide-details dense class="cm-input cm-input--search" color="#198beb"></v-text-field>
      </div>

      <!-- SMS LOGS TAB -->
      <div v-show="activeTab === 1">
        <div class="table-scroll-wrapper">
          <v-data-table
            :headers="logHeaders"
            :items="logs"
            :loading="loading"
            :items-per-page="logsPerPage"
            :search="search"
            hide-default-footer
            class="sms-table"
          >
            <template v-slot:item.created_at="{ item }">
              <span style="white-space: nowrap;">{{ formatDate(item.created_at) }}</span>
            </template>
            <template v-slot:item.team_name="{ item }">
              <span class="text-truncate-cell">{{ item.team_name }}</span>
            </template>
            <template v-slot:item.name="{ item }">
              <span class="text-truncate-cell">{{ item.name }}</span>
            </template>
            <template v-slot:item.email="{ item }">
              <span class="text-truncate-cell">{{ item.email }}</span>
            </template>
            <template v-slot:item.phone_number="{ item }">
              <span class="text-truncate-cell">{{ item.phone_number }}</span>
            </template>
            <template v-slot:item.template="{ item }">
              <span class="text-truncate-cell">{{ item.template }}</span>
            </template>
            <template v-slot:item.status="{ item }">
              <span class="text-xs-right table-f" style="text-transform: capitalize; display: inline-block !important; font-size: 11px !important;">
                <v-icon class="status-icon custom-status-icon" :style="{ color: getStatusDotColor(item.status) }">brightness_1</v-icon>
                {{ item.status.replace(/_/g, ' ') }}
              </span>
            </template>
            <template v-slot:item.message_body="{ item }">
              <span style="white-space: nowrap;">{{ formatDate(item.created_at) }}</span>
            </template>
            <template v-slot:item.error="{ item }">
              <span v-if="item.error" class="text-truncate-cell" style="word-break: break-word;">{{ item.error }}</span>
            </template>
            <template v-slot:item.sms_text="{ item }">
              <span class="text-truncate-cell">{{ item.message_body }}</span>
            </template>
          </v-data-table>
        </div>
      </div>

      <!-- CONSENTED USERS TAB -->
      <div v-show="activeTab === 0">
        <div class="table-scroll-wrapper">
          <v-data-table
            :headers="userHeaders"
            :items="filteredUsers"
            :loading="loadingUsers"
            :items-per-page="usersPerPage"
            :search="search"
            hide-default-footer
            class="sms-table users-table"
            sort-by="created_at"
            :sort-desc="true"
          >
            <template v-slot:item.team_name="{ item }">
              <span class="text-truncate-cell">{{ item.team_name }}</span>
            </template>
            <template v-slot:item.name="{ item }">
              <span class="text-truncate-cell">{{ item.name }}</span>
            </template>
            <template v-slot:item.phone_number="{ item }">
              <span class="text-truncate-cell">{{ item.phone_number }}</span>
            </template>
            <template v-slot:item.email="{ item }">
              <span class="text-truncate-cell">{{ item.email }}</span>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span style="white-space: nowrap;">{{ formatDate(item.created_at) }}</span>
            </template>
            <template v-slot:header.status="{ header }">
              <v-menu offset-y :close-on-content-click="true" nudge-bottom="4">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="status-col-filter">
                    {{ userStatusFilter || header.text }}
                    <v-icon small class="status-col-filter__arrow">arrow_drop_down</v-icon>
                  </span>
                </template>
                <v-list dense class="status-col-menu">
                  <v-list-item @click="userStatusFilter = null">
                    <v-list-item-title class="status-col-menu__item">All</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-for="opt in userStatusOptions.filter(o => o.value)" :key="opt.value" @click="userStatusFilter = opt.value">
                    <v-list-item-title class="status-col-menu__item">
                      <v-icon class="cm-dot" :style="{ color: opt.value === 'Active' ? '#2e7d32' : opt.value === 'Invited' ? '#1565C0' : opt.value === 'Onboarding' ? '#FF8F00' : '#9e9e9e' }">brightness_1</v-icon>
                      {{ opt.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.status="{ item }">
              <span style="font-size: 11px; white-space: nowrap;">
                <v-icon class="status-icon custom-status-icon" :style="{ color: item.status === 'Active' ? '#2e7d32' : item.status === 'Invited' ? '#1565C0' : item.status === 'Onboarding' ? '#FF8F00' : item.status === 'Cancelled' ? '#C62828' : item.status === 'Deleted' ? '#C62828' : '#b0bec5' }">brightness_1</v-icon>
                {{ item.status || '—' }}
              </span>
            </template>
            <template v-slot:item.sms_consent="{ item }">
              <span style="font-size: 11px;" :title="consentTooltip(item.sms_consent, item.sms_consent_method)">
                <v-icon class="status-icon custom-status-icon" :style="{ color: consentDotColor(item.sms_consent, item.sms_consent_method) }">brightness_1</v-icon>
                {{ item.sms_consent ? 'Yes' : 'No' }}
              </span>
            </template>
            <template v-slot:item.email_consent="{ item }">
              <span style="font-size: 11px;" :title="consentTooltip(item.email_consent, item.email_consent_method)">
                <v-icon class="status-icon custom-status-icon" :style="{ color: consentDotColor(item.email_consent, item.email_consent_method) }">brightness_1</v-icon>
                {{ item.email_consent ? 'Yes' : 'No' }}
              </span>
            </template>
            <template v-slot:item.sms_unsubscribed="{ item }">
              <span style="text-transform: capitalize; font-size: 11px;">
                <v-icon class="status-icon custom-status-icon" :style="{ color: item.sms_unsubscribed ? '#C62828' : '#b0bec5' }">brightness_1</v-icon>
                {{ item.sms_unsubscribed ? 'Yes' : 'No' }}
              </span>
            </template>
            <template v-slot:item.email_unsubscribed="{ item }">
              <span style="text-transform: capitalize; font-size: 11px;" :title="emailUnsubTooltip(item)">
                <v-icon class="status-icon custom-status-icon" :style="{ color: item.email_unsubscribed ? '#C62828' : '#b0bec5' }">brightness_1</v-icon>
                {{ item.email_unsubscribed ? 'Yes' : 'No' }}
              </span>
            </template>
            <template v-slot:item.sms_consent_at="{ item }">
              <span style="white-space: nowrap;">{{ formatDate(item.sms_consent_at) }}</span>
            </template>
            <template v-slot:item.email_consent_at="{ item }">
              <span style="white-space: nowrap;">{{ formatDate(item.email_consent_at) }}</span>
            </template>
            <template v-slot:item.sms_consent_method="{ item }">
              <span class="text-truncate-cell" style="text-transform: capitalize;">{{ (item.sms_consent_method || '').replace(/_/g, ' ') }}</span>
            </template>
            <template v-slot:item.sms_consent_ip="{ item }">
              <span class="text-truncate-cell">{{ item.sms_consent_ip }}</span>
            </template>
            <template v-slot:item.sms_consent_url="{ item }">
              <span class="text-truncate-cell">{{ item.sms_consent_url }}</span>
            </template>
            <template v-slot:item.sms_consent_text="{ item }">
              <span class="text-truncate-cell">{{ item.sms_consent_text }}</span>
            </template>
            <template v-slot:item.email_consent_text="{ item }">
              <span class="text-truncate-cell">{{ item.email_consent_text }}</span>
            </template>
            <template v-slot:item.sms_consent_version="{ item }">
              <span class="text-truncate-cell">{{ item.sms_consent_version }}</span>
            </template>
          </v-data-table>
        </div>
      </div>

      <!-- SMS CHECK TAB -->
      <div v-show="activeTab === 2">
        <div class="sms-check-section">
          <p class="sms-check-section__description">Enter a 10-digit phone number to check if we are allowed to send them text messages.</p>
          <div class="sms-check-section__form">
            <input
              v-model="smsCheckPhone"
              type="tel"
              maxlength="10"
              placeholder="(123) 456-7890"
              class="sms-check-section__input"
              @keyup.enter="runSmsCheck"
            />
            <v-btn
              color="#29ABE2"
              dark
              depressed
              :loading="smsCheckLoading"
              @click="runSmsCheck"
              style="text-transform: none; margin-left: 12px;"
            >Check</v-btn>
          </div>
          <div v-if="smsCheckResult" class="sms-check-section__result" :class="'sms-check-section__result--' + (smsCheckResult.would_send ? 'eligible' : 'blocked')">
            <div class="sms-check-section__status">
              <v-icon :color="smsCheckResult.would_send ? '#2e7d32' : '#C62828'" style="margin-right: 8px;">
                {{ smsCheckResult.would_send ? 'check_circle' : 'cancel' }}
              </v-icon>
              <span class="sms-check-section__status-text">
                {{ smsCheckStatusText }}
              </span>
            </div>
            <div class="sms-check-section__details">
              <div v-if="smsCheckResult.name"><strong>Name:</strong> {{ smsCheckResult.name }}</div>
              <div><strong>Phone:</strong> {{ smsCheckResult.phone_number }}</div>
              <div><strong>SMS Consent:</strong> {{ smsCheckResult.sms_consent === true ? 'Yes' : 'No' }}</div>
              <div v-if="smsCheckResult.sms_consent_at"><strong>Consent Date:</strong> {{ formatDate(new Date(smsCheckResult.sms_consent_at._seconds ? smsCheckResult.sms_consent_at._seconds * 1000 : smsCheckResult.sms_consent_at)) }}</div>
              <div v-if="smsCheckResult.sms_unsubscribed_at"><strong>Unsubscribed Date:</strong> {{ formatDate(new Date(smsCheckResult.sms_unsubscribed_at._seconds ? smsCheckResult.sms_unsubscribed_at._seconds * 1000 : smsCheckResult.sms_unsubscribed_at)) }}</div>
            </div>
          </div>
          <div v-if="smsCheckError" class="sms-check-section__error">{{ smsCheckError }}</div>
        </div>
      </div>

      <div class="sombra"></div>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config/constants';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

export default {
  name: 'SmsLogs',
  data: () => ({
    loading: false,
    loadingUsers: false,
    activeTab: 0,
    search: '',
    startDate: null,
    endDate: null,
    startDateMenu: false,
    endDateMenu: false,
    statusFilter: null,
    // SMS Logs - cursor-based pagination
    logs: [],
    logsTotal: 0,
    logsPage: 1,
    logsPerPage: -1,
    logsHasNext: false,
    logsHasPrev: false,
    logsNextCursor: null,
    logsPrevCursor: null,
    logStatusCounts: [],
    // Users - cursor-based pagination
    users: [],
    usersPage: 1,
    usersPerPage: -1,
    usersHasNext: false,
    usersHasPrev: false,
    usersNextCursor: null,
    usersPrevCursor: null,
    userCounts: { sms_consent: 0, email_consent: 0, sms_unsubscribed: 0, email_unsubscribed: 0 },
    userStatusFilter: null,
    usersStartDate: null,
    usersEndDate: null,
    usersStartDateMenu: false,
    usersEndDateMenu: false,
    // SMS Check
    smsCheckPhone: '',
    smsCheckResult: null,
    smsCheckError: null,
    smsCheckLoading: false,
    logHeaders: [
      { text: 'REGISTERED', value: 'created_at', width: '120px', sortable: true, class: 'frozen-col frozen-col-0', cellClass: 'frozen-col frozen-col-0' },
      { text: 'TEAM NAME', value: 'team_name', width: '130px', sortable: true, class: 'frozen-col frozen-col-1', cellClass: 'frozen-col frozen-col-1' },
      { text: 'NAME', value: 'name', width: '130px', sortable: true, class: 'frozen-col frozen-col-2', cellClass: 'frozen-col frozen-col-2' },
      { text: 'ROLE', value: 'role', width: '90px', sortable: true },
      { text: 'EMAIL', value: 'email', width: '160px', sortable: true, class: 'frozen-col frozen-col-3', cellClass: 'frozen-col frozen-col-3' },
      { text: 'PHONE', value: 'phone_number', width: '130px', sortable: true, class: 'frozen-col frozen-col-4', cellClass: 'frozen-col frozen-col-4' },
      { text: 'TEMPLATE', value: 'template', width: '110px', sortable: true, class: 'frozen-col frozen-col-5', cellClass: 'frozen-col frozen-col-5' },
      { text: 'STATUS', value: 'status', width: '140px', sortable: true },
      { text: 'LAST MESSAGE', value: 'message_body', width: '150px', sortable: true },
      { text: 'ERROR', value: 'error', width: '140px', sortable: true },
      { text: 'TEXT', value: 'sms_text', width: '200px', sortable: false },
    ],
    userHeaders: [
      { text: 'REGISTERED', value: 'created_at', width: '120px', sortable: true, class: 'uf-col uf-col-0', cellClass: 'uf-col uf-col-0' },
      { text: 'TEAM NAME', value: 'team_name', width: '130px', sortable: true, class: 'uf-col uf-col-1', cellClass: 'uf-col uf-col-1' },
      { text: 'NAME', value: 'name', width: '130px', sortable: true, class: 'uf-col uf-col-2', cellClass: 'uf-col uf-col-2' },
      { text: 'ROLE', value: 'role', width: '90px', sortable: true },
      { text: 'PHONE', value: 'phone_number', width: '120px', sortable: true, class: 'uf-col uf-col-3', cellClass: 'uf-col uf-col-3' },
      { text: 'EMAIL', value: 'email', width: '160px', sortable: true, class: 'uf-col uf-col-4', cellClass: 'uf-col uf-col-4' },
      { text: 'STATUS', value: 'status', width: '100px', sortable: false },
      { text: 'SMS', value: 'sms_consent', width: '55px', sortable: true, class: 'uf-col uf-col-5', cellClass: 'uf-col uf-col-5' },
      { text: 'EMAIL', value: 'email_consent', width: '55px', sortable: true, class: 'uf-col uf-col-6', cellClass: 'uf-col uf-col-6' },
      { text: 'SMS UNSUB', value: 'sms_unsubscribed', width: '70px', sortable: true, class: 'uf-col uf-col-7', cellClass: 'uf-col uf-col-7' },
      { text: 'EMAIL UNSUB', value: 'email_unsubscribed', width: '80px', sortable: true },
      { text: 'SMS DATE', value: 'sms_consent_at', width: '120px', sortable: true },
      { text: 'EMAIL DATE', value: 'email_consent_at', width: '120px', sortable: true },
      { text: 'VERSION', value: 'sms_consent_version', width: '70px', sortable: true },
      { text: 'METHOD', value: 'sms_consent_method', width: '90px', sortable: true },
      { text: 'IP', value: 'sms_consent_ip', width: '110px', sortable: true },
      { text: 'URL', value: 'sms_consent_url', width: '130px', sortable: true },
      { text: 'SMS CONSENT TEXT', value: 'sms_consent_text', width: '140px', sortable: true },
      { text: 'EMAIL CONSENT TEXT', value: 'email_consent_text', width: '140px', sortable: true },
    ],
  }),
  watch: {
    activeTab(val) {
      if (val === 0 && this.users.length === 0) this.fetchUsers();
      if (val === 1 && this.logs.length === 0) this.fetchLogs();
    },
  },
  computed: {
    perPageOptions() {
      return [
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
        { text: '100', value: 100 },
        { text: 'All', value: -1 },
      ];
    },
    filteredUsers() {
      if (!this.userStatusFilter) return this.users;
      return this.users.filter(u => u.status === this.userStatusFilter);
    },
    userStatusOptions() {
      const statuses = [...new Set(this.users.map(u => u.status).filter(Boolean))].sort();
      return [{ text: 'All', value: null }, ...statuses.map(s => ({ text: s, value: s }))];
    },
    userStatusCounts() {
      const counts = {};
      this.users.forEach(u => {
        const s = u.status || 'Unknown';
        counts[s] = (counts[s] || 0) + 1;
      });
      return Object.entries(counts).map(([status, count]) => ({ status, count })).sort((a, b) => b.count - a.count);
    },
    smsCheckStatusText() {
      if (!this.smsCheckResult) return '';
      const r = this.smsCheckResult;
      if (r.would_send) return 'Yes — this person has opted in and can receive text messages.';
      if (r.reason === 'no_consent') return 'No — this person has not given consent to receive text messages.';
      if (r.reason === 'unsubscribed') return 'No — this person has opted out by texting STOP. They will not receive any text messages.';
      if (r.reason === 'user_not_found') return 'No phone number found — this number is not in the system.';
      return 'No — this person cannot receive text messages.';
    },
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    async getAuthHeader() {
      const user = firebase.auth().currentUser;
      if (user) {
        const token = await user.getIdToken();
        return { 'X-Firebase-Token': token };
      }
      return {};
    },
    async fetchLogs(cursor, direction) {
      this.loading = true;
      try {
        const headers = await this.getAuthHeader();
        const params = { limit: this.logsPerPage === -1 ? 10000 : this.logsPerPage };
        if (cursor && this.logsPerPage !== -1) {
          params.cursor = cursor;
          params.direction = direction || 'next';
        }
        if (this.statusFilter) params.status = this.statusFilter;
        if (this.startDate) params.start_date = this.startDate;
        if (this.endDate) params.end_date = this.endDate;

        const response = await axios.get(config.api_url + 'sms/logs', { headers, params });
        const data = response.data.data;
        this.logs = data.logs.map(l => ({
          ...l,
          created_at: l.created_at ? new Date(l.created_at._seconds ? l.created_at._seconds * 1000 : l.created_at) : null,
        }));
        this.logsTotal = data.total;
        this.logsHasNext = data.has_next;
        this.logsHasPrev = data.has_prev;
        this.logsNextCursor = data.next_cursor;
        this.logsPrevCursor = data.prev_cursor;
        this.logStatusCounts = data.status_counts || [];
      } catch (error) {
        console.error('[SMS Logs] Error:', error.message);
      }
      this.loading = false;
    },
    fetchLogsNext() {
      if (this.logsNextCursor) {
        this.logsPage++;
        this.fetchLogs(this.logsNextCursor, 'next');
      }
    },
    fetchLogsPrev() {
      if (this.logsPrevCursor) {
        this.logsPage = Math.max(1, this.logsPage - 1);
        this.fetchLogs(this.logsPrevCursor, 'prev');
      }
    },
    resetAndFetchLogs() {
      this.logsPage = 1;
      this.fetchLogs();
    },
    async fetchUsers(cursor, direction) {
      this.loadingUsers = true;
      try {
        const headers = await this.getAuthHeader();
        const params = { limit: this.usersPerPage === -1 ? 10000 : this.usersPerPage };
        if (cursor && this.usersPerPage !== -1) {
          params.cursor = cursor;
          params.direction = direction || 'next';
        }
        if (this.usersStartDate) params.start_date = this.usersStartDate;
        if (this.usersEndDate) params.end_date = this.usersEndDate;

        const response = await axios.get(config.api_url + 'users/consent', { headers, params });
        const data = response.data.data;
        this.users = data.users.map(u => ({
          ...u,
          created_at: u.created_at ? new Date(u.created_at._seconds ? u.created_at._seconds * 1000 : u.created_at) : null,
          sms_consent_at: u.sms_consent_at ? new Date(u.sms_consent_at._seconds ? u.sms_consent_at._seconds * 1000 : u.sms_consent_at) : null,
          email_consent_at: u.email_consent_at ? new Date(u.email_consent_at._seconds ? u.email_consent_at._seconds * 1000 : u.email_consent_at) : null,
          email_unsubscribed_at: u.email_unsubscribed_at ? new Date(u.email_unsubscribed_at._seconds ? u.email_unsubscribed_at._seconds * 1000 : u.email_unsubscribed_at) : null,
        }));
        this.usersHasNext = data.has_next;
        this.usersHasPrev = data.has_prev;
        this.usersNextCursor = data.next_cursor;
        this.usersPrevCursor = data.prev_cursor;
        this.userCounts = data.counts || { sms_consent: 0, email_consent: 0, sms_unsubscribed: 0, email_unsubscribed: 0 };
      } catch (error) {
        console.error('[Users] Error:', error.message);
      }
      this.loadingUsers = false;
    },
    fetchUsersNext() {
      if (this.usersNextCursor) {
        this.usersPage++;
        this.fetchUsers(this.usersNextCursor, 'next');
      }
    },
    fetchUsersPrev() {
      if (this.usersPrevCursor) {
        this.usersPage = Math.max(1, this.usersPage - 1);
        this.fetchUsers(this.usersPrevCursor, 'prev');
      }
    },
    resetAndFetchUsers() {
      this.usersPage = 1;
      this.fetchUsers();
    },
    consentDotColor(hasConsent, method) {
      if (!hasConsent) return '#b0bec5';
      if (method === 'signup_form_checkbox' || method === 'implied_platform_consent') return '#2e7d32';
      return '#b0bec5'; // Admin Backfill or other — backfilled, not user-initiated
    },
    consentTooltip(hasConsent, method) {
      if (!hasConsent) return '';
      if (method === 'signup_form_checkbox') return 'Consented via signup form';
      if (method === 'implied_platform_consent') return 'Consented at activation';
      if (method === 'Admin Backfill') return 'Admin backfill — not user-initiated';
      return '';
    },
    emailUnsubTooltip(item) {
      if (!item || !item.email_unsubscribed) return '';
      const parts = [];
      if (item.email_unsubscribed_source) parts.push(`Source: ${item.email_unsubscribed_source}`);
      if (item.email_unsubscribed_reason) parts.push(`Reason: ${item.email_unsubscribed_reason}`);
      if (item.email_unsubscribed_at) parts.push(`At: ${this.formatDate(item.email_unsubscribed_at)}`);
      return parts.join(' · ');
    },
    toggleLogStatus(status) {
      this.statusFilter = this.statusFilter === status ? null : status;
      this.resetAndFetchLogs();
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const m = d.getMonth() + 1;
      const day = d.getDate();
      const y = String(d.getFullYear()).slice(-2);
      const h = d.getHours();
      const min = String(d.getMinutes()).padStart(2, '0');
      const ampm = h >= 12 ? 'PM' : 'AM';
      const h12 = h % 12 || 12;
      return `${m}/${String(day).padStart(2, '0')}/${y}, ${h12}:${min} ${ampm}`;
    },
    getStatusDotColor(status) {
      const colors = { sent: '#2e7d32', failed: '#C62828', rate_limited: '#E65100', skipped_no_consent: '#6A1B9A', skipped_unsubscribed: '#6A1B9A', opted_out_twilio: '#C62828', opt_in: '#2e7d32' };
      return colors[status] || '#b0bec5';
    },
    exportCsv() {
      const h = ['Registered', 'Team Name', 'Name', 'Email', 'Phone', 'Template', 'Status', 'Last Message', 'Twilio SID', 'Error'];
      const rows = this.logs.map(l => [this.formatDate(l.created_at), l.team_name||'', l.name||'', l.email||'', l.phone_number||'', l.template||'', l.status||'', this.formatDate(l.created_at), l.twilio_sid||'', (l.error||'').replace(/"/g,'""')].map(v => `"${v}"`).join(','));
      this.downloadCsv([h.join(','), ...rows].join('\n'), 'sms_logs');
    },
    exportUsersCsv() {
      const h = ['Name', 'Phone', 'Email', 'SMS Consent', 'Email Consent', 'SMS Unsubscribed', 'Email Unsubscribed', 'Email Unsub Date', 'Email Unsub Source', 'Email Unsub Reason', 'SMS Consent Date', 'Email Consent Date', 'Version', 'Method', 'IP', 'URL', 'SMS Consent Text', 'Email Consent Text'];
      const rows = this.users.map(u => [u.name, u.phone_number, u.email, u.sms_consent?'Yes':'No', u.email_consent?'Yes':'No', u.sms_unsubscribed?'Yes':'No', u.email_unsubscribed?'Yes':'No', this.formatDate(u.email_unsubscribed_at), u.email_unsubscribed_source, u.email_unsubscribed_reason, this.formatDate(u.sms_consent_at), this.formatDate(u.email_consent_at), u.sms_consent_version, u.sms_consent_method, u.sms_consent_ip, u.sms_consent_url, u.sms_consent_text, u.email_consent_text].map(v => `"${(v||'').replace(/"/g,'""')}"`).join(','));
      this.downloadCsv([h.join(','), ...rows].join('\n'), 'consent_users');
    },
    async runSmsCheck() {
      const digits = this.smsCheckPhone.replace(/\D/g, '');
      if (digits.length !== 10) return;
      this.smsCheckLoading = true;
      this.smsCheckResult = null;
      this.smsCheckError = null;
      try {
        const headers = await this.getAuthHeader();
        const response = await axios.get(config.api_url + 'sms/check', {
          headers,
          params: { phone_number: '+1' + digits }
        });
        this.smsCheckResult = response.data.data;
      } catch (error) {
        this.smsCheckError = error.response ? error.response.data.message : error.message;
      }
      this.smsCheckLoading = false;
    },
    downloadCsv(csv, prefix) {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${prefix}_${new Date().toISOString().split('T')[0]}.csv`;
      link.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped lang="scss">
// Shared stat/pipe/dot classes for header bar
.cm-stat {
  font-size: 10px;
  white-space: nowrap;
}
.cm-stat--click {
  cursor: pointer;
}
.cm-pipe {
  color: #ccc;
  font-size: 10px;
}

.sms-logs-wrapper {
  padding: 0 12px 0 12px;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.sms-custom-container {
  max-width: 100% !important;
  min-height: auto !important;
  margin: 0 !important;
  padding: 2px 0 0 !important;
  box-shadow: none !important;
  border: none !important;
}

.custom-o-white {
  height: 32px !important;
  width: 149px !important;
  top: 2px;
}

.table_btn {
  color: #2bace2;
  font-size: 13px;
  font-weight: 400;
  text-transform: capitalize;
  letter-spacing: normal;
}

.sms-check-section {
  padding: 20px 24px;

  &__description {
    color: #555;
    font-size: 14px;
    margin-bottom: 16px;
  }

  &__input {
    width: 180px;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    outline: none;

    &:focus {
      border-color: #29ABE2;
    }
  }

  &__form {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  &__result {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;

    &--eligible {
      background-color: #e8f5e9;
      border-color: #a5d6a7;
    }

    &--blocked {
      background-color: #fce4ec;
      border-color: #ef9a9a;
    }
  }

  &__status {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }

  &__details {
    font-size: 13px;
    line-height: 1.8;
    color: #333;
  }

  &__error {
    color: #C62828;
    font-size: 13px;
    margin-top: 12px;
  }
}
</style>

<style lang="scss">
// Icon dot used in stats bar and column filter
.cm-dot {
  font-size: 5px !important;
  margin-right: 1px;
}

// Force Vuetify v-text-field internals to match page font (10px)
.cm-input {
  max-width: 70px;

  .v-input__slot {
    min-height: 20px !important;
  }
  input,
  .v-text-field__slot input,
  input::placeholder {
    font-size: 10px !important;
    font-family: Roboto, sans-serif !important;
  }
  .v-input__append-inner {
    margin-top: 0 !important;
    .v-icon {
      font-size: 14px !important;
    }
  }
}

.cm-input--search {
  max-width: 100px;
}

// Status column filter dropdown in header
.status-col-filter {
  cursor: pointer;
  font-size: 10px !important;
  font-weight: 700 !important;
  color: #979797 !important;
  text-transform: uppercase;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;

  &__arrow {
    font-size: 16px !important;
    color: #979797 !important;
    margin-left: -2px;
  }

  &:hover {
    color: #29ABE2 !important;
    .status-col-filter__arrow { color: #29ABE2 !important; }
  }
}

.status-col-menu {
  min-width: 120px !important;
  padding: 4px 0 !important;

  &__item {
    font-size: 11px !important;
    display: flex !important;
    align-items: center;
    gap: 4px;
  }

  .v-list-item {
    min-height: 28px !important;
    padding: 0 12px !important;
  }
}

.status-stats-bar {
  display: flex;
  align-items: center;
  padding: 10px 24px;
  margin-bottom: 8px;
  background-color: #f8f9fb;
  border-bottom: 1px solid #e8ebef;

  &__divider {
    width: 1px;
    height: 20px;
    background-color: #d0d5dd;
    margin: 0 20px;
    flex-shrink: 0;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 6px;

    &--clickable {
      cursor: pointer;
      &:hover .status-stats-bar__label {
        color: #29ABE2;
      }
    }
  }

  &__dot {
    font-size: 8px !important;
  }

  &__label {
    color: #717e91;
    font-size: 13px;
    font-weight: 500;
    text-transform: capitalize;
  }

  &__count {
    color: #29ABE2;
    font-size: 13px;
    font-weight: 600;
  }

  &__actions {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 8px;
  }
}


.sms-table {
  .v-data-footer { border-top: none !important; }

  table {
    margin: 0 auto;
    width: 100%;
  }

  thead tr th {
    height: 24px !important;
    font-size: 10px !important;
    font-weight: 700 !important;
    text-transform: uppercase;
    font-family: Roboto, sans-serif !important;
    color: #979797 !important;
    white-space: nowrap;
    border-bottom: none !important;
    padding: 0 4px !important;

    .v-data-table-header__icon {
      color: #29ABE2 !important;
      margin-left: 2px;
      font-size: 14px !important;
      opacity: 0 !important;
      display: inline-block !important;
      vertical-align: middle;
    }

    &.active .v-data-table-header__icon {
      opacity: 1 !important;
    }

    span {
      position: static !important;
      top: auto !important;
      padding-right: 0 !important;
      line-height: normal !important;
      display: inline !important;
    }
  }

  tbody tr {
    box-shadow: none !important;

    td {
      height: 20px !important;
      font-size: 10px !important;
      font-weight: 400;
      padding: 0 4px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: 1px solid #e0e0e0 !important;
    }
  }

  th.text-center {
    text-align: center !important;
  }
  td.col-center {
    text-align: center !important;
    overflow: visible !important;
  }
}

.table-scroll-wrapper {
  overflow: visible;
  max-width: 100%;
}

// Frozen columns — sticky left positioning
.sms-table {
  .v-data-table__wrapper {
    overflow-x: scroll !important;
    overflow-y: auto !important;
    max-height: calc(100vh - 180px);

    // Scrollbar track starts after frozen columns (670px)
    &::-webkit-scrollbar {
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      margin-left: 670px;
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #c0c0c0;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #999;
    }
    // Firefox
    scrollbar-width: thin;
    scrollbar-color: #c0c0c0 transparent;
  }

  table {
    table-layout: fixed !important;
    // Force table wider than container so scrollbar appears
    // Frozen (120+130+130+160+130+110=680) + scrollable columns get extra space
    width: calc(100% + 400px) !important;
    min-width: 1400px !important;
  }

  .frozen-col {
    position: sticky !important;
    z-index: 1 !important;
    background: #fff !important;
  }

  thead .frozen-col {
    z-index: 3 !important;
    background: #fff !important;
  }

  // Cumulative left offsets based on column widths
  .frozen-col-0 { left: 0 !important; }          // REGISTERED: 0
  .frozen-col-1 { left: 120px !important; }       // TEAM NAME: after 120px
  .frozen-col-2 { left: 250px !important; }       // NAME: after 120+130
  .frozen-col-3 { left: 380px !important; }       // EMAIL: after 120+130+130
  .frozen-col-4 { left: 540px !important; }       // PHONE: after 120+130+130+160
  .frozen-col-5 {                                  // TEMPLATE: after 120+130+130+160+130
    left: 670px !important;
    border-right: 2px solid #e0e0e0 !important;   // Visual divider before scrollable area
  }

  tbody tr:hover .frozen-col {
    background: #f5f5f5 !important;
  }
}

.text-truncate-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.cursor-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  border-top: 1px solid #e8ebef;

  &__info {
    color: #717e91;
    font-size: 13px;
  }

  &__controls {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__page {
    color: #333;
    font-size: 13px;
    font-weight: 500;
    min-width: 60px;
    text-align: center;
  }
}

// Users table — frozen columns before SMS DATE
.users-table {
  .v-data-table__wrapper {
    overflow-x: scroll !important;
    overflow-y: auto !important;
    max-height: calc(100vh - 180px);

    &::-webkit-scrollbar {
      height: 8px;
    }
    // Frozen width: 130+130+120+160+120+55+55+60 = 830px
    &::-webkit-scrollbar-track {
      margin-left: 830px;
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #c0c0c0;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #999;
    }
    scrollbar-width: thin;
    scrollbar-color: #c0c0c0 transparent;
  }

  table {
    table-layout: fixed !important;
    width: calc(100% + 500px) !important;
    min-width: 1600px !important;
  }

  .uf-col {
    position: sticky !important;
    z-index: 1 !important;
    background: #fff !important;
  }

  thead .uf-col {
    z-index: 3 !important;
    background: #fff !important;
  }

  // Cumulative left offsets: REGISTERED(120) TEAM(130) NAME(130) PHONE(120) EMAIL(160) SMS(55) EMAIL(55) UNSUB(60)
  .uf-col-0 { left: 0 !important; }
  .uf-col-1 { left: 120px !important; }
  .uf-col-2 { left: 250px !important; }
  .uf-col-3 { left: 380px !important; }
  .uf-col-4 { left: 500px !important; }
  .uf-col-5 { left: 660px !important; }
  .uf-col-6 { left: 715px !important; }
  .uf-col-7 {
    left: 770px !important;
    border-right: 2px solid #e0e0e0 !important;
  }

  tbody tr:hover .uf-col {
    background: #f5f5f5 !important;
  }
}
</style>
